import { useState, useEffect, Fragment } from 'react';
import { Typography } from '../../../../core/components/molecules/Typography';
import { ContentWrapper, LineContent, Lines, Paper } from './variants';
import { useBoardConfig } from '../../../../core/hooks/useBoardConfig';
import BrainLoadingWrapper from '../../../../core/components/molecules/BrainLoading';

interface IEssayCorrectedPaper {
  correction: number;
  fontSize: 'small' | 'default' | 'large';
  essayText: string;
  essayTitle: string;
  isLoading: boolean;
}

export default function EssayWaitingPaper({
  correction,
  fontSize,
  essayText,
  essayTitle,
  isLoading,
}: IEssayCorrectedPaper) {
  const { board } = useBoardConfig(Number(correction) || 2);

  const [paperLines, setPaperLines] = useState<number>(0);
  const [paperHeight, setPaperHeight] = useState<number>(900);

  const sizes = {
    default: 16,
    small: 14,
    large: 18,
  };

  const spaces = {
    default: 2,
    small: 1.5,
    large: 2,
  };

  useEffect(() => {
    const LINE_HEIGHT = 30;
    let lines = board.lines;

    //Ajustar linhas para display de até 320px
    if(window.innerWidth <= 375) {
      const totalLines = Math.ceil(essayText.length/37);

      lines = totalLines + 1;
    }

    //Ajustar linhas para display de até 425px
    if(window.innerWidth <= 425 && window.innerWidth > 375) {
      const totalLines = Math.ceil(essayText.length/42);

      lines = totalLines;
    }
    
    setPaperLines(lines);
    setPaperHeight(lines * LINE_HEIGHT + 20);
  }, [essayText]);

  const formatText = (text:string) => {
    const regex = /\n/g;
  
    return text.replace(regex, "<br/>");
  }

  if(isLoading) {
    return <BrainLoadingWrapper />;
  }

  return (
    <Fragment>
      <Typography className='text-center'>
        {essayTitle}
      </Typography>
      <div className={Paper()} style={{ height: paperHeight }}>
        <div className='absolute z-0 h-full w-full'>
          {[...Array(paperLines)].map((__, i) => (
            <div className={Lines()} key={i}>
              <div className={LineContent()}>
                <div className='h-4 w-4 rounded-pill bg-mono-color-lighter' />
                <Typography
                  size='default'
                  className={
                    i + 1 <= board.lines
                      ? 'text-mono-color-darkest'
                      : 'text-red-500'
                  }
                >
                  {i + 1}
                </Typography>
              </div>
            </div>
          ))}
        </div>

        <div className={ContentWrapper()}>
          <div
            style={{
              wordSpacing: spaces[fontSize],
              fontSize: sizes[fontSize],
            }}
            className='inline-flex w-full px-[13px] py-1 text-left font-notoSans font-normal text-mono-color-darkest leading-[30px]'
            dangerouslySetInnerHTML={{ __html: formatText(essayText) }}
          />
        </div>
      </div>
    </Fragment>
  );
}
